export default __webpack_public_path__ + "static/media/rainforest.213ae562.jpeg";